// Copyright (c) 2017 Deere & Company

import Audit from '@deere/cps-it.warranty-model-factory/lib/audit';
import t from 'tcomb';

const AuditList = t.list(Audit, 'AuditList');

export const getDefaultState = () => new AuditList([]);

export default AuditList;



// WEBPACK FOOTER //
// ./src/tcsm/audits/state/audit-list.js